import { z } from "zod";

// TODO: Update password requirements
const passwordZodString = z
  .string()
  .min(1, "Password must be at least 1 characters");

export const AuthSchema = z.object({
  email: z.string().trim().toLowerCase().email(),
  password: passwordZodString,
});

export type TAuthSchema = z.infer<typeof AuthSchema>;

export const EmailSchema = z.object({
  email: z.string().trim().toLowerCase().email(),
});

export type TEmailSchema = z.infer<typeof EmailSchema>;

export const NewPasswordSchema = z
  .object({
    password: passwordZodString,
    confirmPassword: passwordZodString,
  })
  .refine((data) => data.password === data.confirmPassword, {
    path: ["confirmPassword"],
    message: "Passwords do not match",
  });

export type TNewPasswordSchema = z.infer<typeof NewPasswordSchema>;
